import React, { useState } from 'react';
import './common/Card.css';
import './AddressCard.css';

const AddressCard = ({ address, onEdit, onDelete, onClick }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    setShowMenu(!showMenu);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    onEdit(address);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    onDelete(address);
  };

  const handleCardClick = () => {
    if (onClick) {
      onClick(address);
    }
  };

  return (
    <div className="card address-card" onClick={handleCardClick}>
      <button className="menu-button" onClick={handleMenuToggle}>
        ⋮
      </button>
      {showMenu && (
        <>
          <div className="menu-overlay" onClick={() => setShowMenu(false)} />
          <div className="menu-dropdown">
            <button className="menu-item" onClick={handleEdit}>
              Редактировать
            </button>
            <button className="menu-item delete" onClick={handleDelete}>
              Удалить
            </button>
          </div>
        </>
      )}
      <div className="address-content">
        <div className="address-city">{address.city}</div>
        <div className="address-street">{address.street}</div>
        <div className="address-building">
          {address.building}
          {address.apartment && ` / ${address.apartment}`}
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
